/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Represents the sorting options for a search operation involving specimens.
 */
export enum SearchSpecimenSortBy {
    CODE = 'code',
    CREATED_AT = 'createdAt',
    PERSON_SIME_CODE = 'personSimeCode',
    PERSON_TARV_CODE = 'personTarvCode',
    PERSON_TESTRAP_CODE = 'personTestrapCode',
}
